import { gameConstants } from '../constants';
import { gameService } from '../services';

export const gameActions = {
  fetchGames,
  fetchBlockedStatus,
  purchaseGame,
  updateBlockedStatusFromSocket,
  markGameAsPlayed
};

function fetchGames(studentid, gameMenu, forceRefresh = false) {
  return dispatch => {
    dispatch(request());

    return gameService.fetchGames(studentid, gameMenu, forceRefresh)
      .then(
        response => {
          const games = Array.isArray(response) ? response : (Array.isArray(response?.data) ? response.data : []);
          dispatch(success(games));
          return games;
        },
        error => {
          dispatch(failure(error));
          return error;
        }
      );
  };

  function request() { return { type: gameConstants.FETCH_GAME_REQUEST } }
  function success(games) { return { type: gameConstants.FETCH_GAME_SUCCESS, games } }
  function failure(error) { return { type: gameConstants.FETCH_GAME_FAILURE, error } }
}

function fetchBlockedStatus(studentid, forceRefresh = false) {
  return dispatch => {
    dispatch(request());

    gameService.fetchBlockedStatus(studentid, forceRefresh)
      .then(
        response => {
          const blockedstatus = response?.data ?? response ?? null;
          dispatch(success(blockedstatus));
        },
        error => {
          dispatch(failure(error));
        }
      );
  };

  function request() { return { type: gameConstants.FETCH_BLOCKEDSTATUS_REQUEST } }
  function success(blockedstatus) { return { type: gameConstants.FETCH_BLOCKEDSTATUS_SUCCESS, blockedstatus } }
  function failure(error) { return { type: gameConstants.FETCH_BLOCKEDSTATUS_FAILURE, error } }
}

function purchaseGame(payload) {
  return dispatch => {
    dispatch(request());

    return gameService.purchaseGame(payload)
      .then(
        response => {
          if (response?.ok === true &&
            response?.responseMessage === "You dont have enough coins to purchase this game") {
            return response;
          }

          const game = response?.data ?? response;
          if (game != null) {
            dispatch(success(game));
          }
          return response;
        },
        error => {
          dispatch(failure(error));
          throw error;
        }
      );
  };

  function request() { return { type: gameConstants.PURCHASE_GAME_REQUEST } }
  function success(game) { return { type: gameConstants.PURCHASE_GAME_SUCCESS, game } }
  function failure(error) { return { type: gameConstants.PURCHASE_GAME_FAILURE, error } }
}

function updateBlockedStatusFromSocket(payload) {
  return (dispatch) => {
    const data = payload && typeof payload === 'object' ? payload : {};
    const studentProfileId = data.studentProfileId ?? data.StudentProfileID ?? null;
    const blockGame = data.BlockGame ?? data.blockGame;
    const blockChat = data.BlockChat ?? data.blockChat;
    const message = data.BlockStatusMessage ?? data.blockStatusMessage ?? data.message ?? '';

    // Prevent a later cached HTTP fetch from overwriting the live socket update.
    gameService.invalidateBlockedStatusCache(studentProfileId);

    dispatch({
      type: gameConstants.UPDATE_BLOCKEDSTATUS_FROM_SOCKET,
      blockedstatus: {
        StudentProfileID: studentProfileId,
        ...(blockGame !== undefined ? { BlockGame: blockGame } : {}),
        ...(blockChat !== undefined ? { BlockChat: blockChat } : {}),
        ...(message !== '' ? { BlockStatusMessage: message } : {}),
      },
    });
  };
}

function markGameAsPlayed(gameId) {
  return {
    type: gameConstants.MARK_GAME_AS_PLAYED,
    gameId,
  };
}
